import {CommonModule} from '@angular/common';
import {Component, inject, Input, OnDestroy, OnInit} from '@angular/core';
import {NxFooterModule} from '@aposin/ng-aquila/footer';
import {NxIconModule} from '@aposin/ng-aquila/icon';
import {NxLinkModule} from '@aposin/ng-aquila/link';
import {TranslateModule} from '@ngx-translate/core';
import {NdbxIconModule} from '@allianz/ngx-ndbx/icon';
import {AnalyticsService} from '../../../services/analytics/analytics.service';
import {
  combineLatest,
  filter,
  map,
  Observable,
  startWith,
  Subject,
  take,
  takeUntil,
  tap,
} from 'rxjs';
import {MotorQuoteDossierDTO, MotorQuoteDTO} from '../../../models/MotorQuoteDTO.interfaces';
import {RouterDataService} from '../../../services/router-data/router-data.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'fq-information-footer',
  imports: [
    NxFooterModule,
    NxLinkModule,
    NxIconModule,
    NdbxIconModule,
    TranslateModule,
    CommonModule,
  ],
  templateUrl: './information-footer.component.html',
  styleUrl: './information-footer.component.scss',
})
export class InformationFooterComponent {
  @Input() isBigInformationFooter!: boolean;
  @Input() pdfLinkText!: string;
  @Input() descriptionWarningsText!: string;
  @Input() descriptionInformationText!: string;

  private analyticsService = inject(AnalyticsService);
  private routerDataService = inject(RouterDataService);

  iconsNameContent = ['visa', 'mastercard', 'paypal'];

  dossier!: MotorQuoteDossierDTO;

  onClick(evt: MouseEvent) {
    this.analyticsService.sendAnalytics({
      componente: 'informazioni',
      cta: 'set_informativi_polizza_auto',
      hit_type: 'event',
      // funnel_type: 'fastquote',
    });
  }

  onHover() {
    const currentMotorData = this.routerDataService.getMotorQuoteObject();
    if (currentMotorData && currentMotorData.response?.FascicoloInformativo)
      this.dossier = currentMotorData.response.FascicoloInformativo;
  }
}
